export default __webpack_public_path__ + "static/media/Screenshot_20230515-161138 - 051 MOHIT GUPTA.50c31be4.jpg";